export enum ModalTypes {
  NATIVE = 'native',
  LATERAL = 'lateral',
  CENTERED = 'centered',
  POPUP = 'popup'
}